export const NAVBAR_MOBILE_HEIGHT = 58;
export const NAVBAR_DESKTOP_HEIGHT = 72;
export const FOOTER_MOBILE_HEIGHT = 48;
export const FOOTER_DESKTOP_HEIGHT = 60;
